if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector(".quantity__input");
        this.currentVariant = this.querySelector(".product-variant-id");
        this.variantSelects = this.querySelectorAll(
          ".color-swatch-wrapper input"
        ); // Select the color options
        this.submitButton = this.querySelector('[type="submit"]');
        this.priceElement = this.querySelector(".product__price");
        this.variants = []; // Initialize variants array (should be populated later)
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector(".product-form__quantity");
        if (!this.quantityForm) return;
        this.setQuantityBoundries();

        // Ensure the first color variant is correctly initialized on page load
        this.selectFirstColorVariant();

        // **Automatically load the variant from the URL (if any)** to make sure the variant ID is set properly
        this.loadVariantFromUrl();

        // Subscribe to variant change event to update price and URL
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section;
            if (event.data.sectionId !== sectionId) return;

            this.updateVariant(event.data.variant);
            this.updateQuantityRules(event.data.sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );

        // Event listener for color selection changes
        this.variantSelects.forEach((colorSwatch) => {
          colorSwatch.addEventListener("change", (event) => {
            const selectedColor = event.target.value;
            this.updateVariant(selectedColor);
          });
        });
      }

      disconnectedCallback() {
        // Clean up event listeners and subscriptions
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      selectFirstColorVariant() {
        if (this.variantSelects && this.variantSelects.length > 0) {
          const firstColorVariant = this.variantSelects[0]; // Select the first color swatch
          firstColorVariant.checked = true; // Mark the first color swatch as selected

          // Now, trigger the variant update based on the first color
          this.updateVariant(firstColorVariant.value); // Update the variant with the selected color
        } else {
          console.error("No color variants available to select.");
        }
      }

      // **Function to load the variant from the URL** (if it exists)
      loadVariantFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get("variant"); // Get the variant from the URL

        if (variantId) {
          this.setVariantById(variantId); // Call the function to select the variant
        }
      }

      // **Function to select the variant by ID**
      setVariantById(variantId) {
        const variant = this.variants.find(
          (v) => v.id.toString() === variantId.toString()
        );

        if (variant) {
          // **Trigger the change on load** to update the price and URL immediately
          this.selectColorVariant(variant); // Select the color for the given variant
          this.updatePrice(variant.price); // Update price
          this.updateURL(variant.id); // Update URL with the selected variant ID
        } else {
          console.error(`Variant with ID ${variantId} not found.`);
        }
      }

      // **Function to select the color variant**
      selectColorVariant(variant) {
        const colorSwatch = Array.from(this.variantSelects).find(
          (input) => input.value === variant.color
        ); // Find the color option
        if (colorSwatch) {
          colorSwatch.checked = true; // Mark as selected
          this.updateVariant(variant.color); // Update the price and URL based on the selected variant
          this.triggerVariantChange(variant); // Trigger the variant change event to update the Add to Cart button
        } else {
          console.error(`Color swatch for ${variant.color} not found.`);
        }
      }

      // **Trigger the variant change event manually**
      triggerVariantChange(variant) {
        const event = new CustomEvent("variantChange", {
          detail: { variant: variant },
        });
        this.dispatchEvent(event); // Dispatch the event to inform other parts of the page about the variant change
      }

      // **Update the variant with the selected color**
      updateVariant(color) {
        if (!color) return;
        const variant = this.findVariantByColor(color);
        if (variant) {
          this.updatePrice(variant.price);
          this.updateURL(variant.id); // Update the URL with the selected variant
        } else {
          console.error(`Variant not found for color: ${color}`);
        }
      }

      // **Update the price element with the new price**
      updatePrice(price) {
        if (this.priceElement) {
          this.priceElement.innerHTML = Shopify.formatMoney(price);
        }
      }

      // **Update the URL with the selected variant ID**
      updateURL(variantId) {
        window.history.replaceState(
          null,
          "",
          `${window.location.pathname}?variant=${variantId}`
        );
      }

      // Find the variant by color (or size, depending on your setup)
      findVariantByColor(color) {
        console.log("variant", this.variants);

        return this.variants.find((variant) => {
          console.log(variant);
          variant.color === color; // Update this based on your variant properties
        });
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector(
          ".quantity__rules-cart .loading-overlay"
        ).classList.remove("hidden");
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
        )
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error("Error fetching quantity rules:", e);
          })
          .finally(() => {
            this.querySelector(
              ".quantity__rules-cart .loading-overlay"
            ).classList.add("hidden");
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(
          `Quantity-Form-${sectionId}`
        );
        const selectors = [
          ".quantity__input",
          ".quantity__rules",
          ".quantity__label",
        ];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === ".quantity__input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
